/*
 * lazy-video.js
 * Hydrates <video data-lazy-video> elements when they enter the viewport.
 * - Sources are authored as <source data-src="…"> with no src attribute, so the
 *   browser does not preload anything until we swap data-src → src.
 * - On intersection: copy data-src to src on each <source>, call video.load(),
 *   then play() if data-autoplay is present (still respects prefers-reduced-motion).
 * - On mobile the element is left dormant if data-mobile-skip is set.
 */
(function () {
  var SELECTOR = 'video[data-lazy-video]';
  var ROOT_MARGIN = '300px';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 989px)').matches;

  function hydrate(video) {
    if (video.dataset.lazyVideoReady === '1') return;
    video.dataset.lazyVideoReady = '1';

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length && !video.dataset.src) return;

    sources.forEach(function (s) {
      var url = s.getAttribute('data-src');
      if (url && !s.src) s.src = url;
    });
    if (video.dataset.src && !video.src) video.src = video.dataset.src;

    try { video.load(); } catch (e) { /* noop */ }

    var shouldAutoplay = video.hasAttribute('data-autoplay') && !prefersReduced;
    if (shouldAutoplay) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked */ });
    }
  }

  function observe(video) {
    if (video.dataset.mobileSkip === '1' && isMobile) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          obs.unobserve(entry.target);
          hydrate(entry.target);
        });
      }, { rootMargin: ROOT_MARGIN });
      io.observe(video);
    } else {
      hydrate(video);
    }
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
